import { render, staticRenderFns } from "./3DShow.vue?vue&type=template&id=1595b56b&scoped=true&"
import script from "./3DShow.vue?vue&type=script&lang=js&"
export * from "./3DShow.vue?vue&type=script&lang=js&"
import style0 from "./3DShow.vue?vue&type=style&index=0&id=1595b56b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595b56b",
  null
  
)

export default component.exports